import React from 'react';

const Footer = ({ data }) => {
  if (!data) return null;

  const networks = data.social.map((network) => {
    return (
      <li key={network.name}>
        <a href={network.url} target="_blank" rel="noopener noreferrer">
          <i className={network.className}></i>
        </a>
      </li>
    );
  });

  return (
    <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social-links">{networks}</ul>

          <ul className="copyright">
            <li>&copy; {new Date().getFullYear()} hightechguru.net</li>
            <li>
              Design by{' '}
              <a title="Guru" href="http://www.hightechguru.net/">
                Guru
              </a>
            </li>
          </ul>
        </div>
        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="#home">
            <i className="icon-up-open"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
